import { Component, inject, OnDestroy, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SubSink } from 'subsink';
import { ProfileApiService } from '../../apiCalls/profile-api.service';
import { CustomSnackbarService } from '../../shared/custom-snackbar.service';
import { UserListData } from '../user-management.component';

@Component({
  selector: 'app-delete-user',
  imports: [MatDialogModule, MatButtonModule],
  templateUrl: './delete-user.component.html',
  styleUrl: './delete-user.component.scss',
})
export class DeleteUserComponent implements OnDestroy {
  private readonly subs = new SubSink();
  private readonly profileApiSvc = inject(ProfileApiService);
  private readonly customSnackbarSvc = inject(CustomSnackbarService);
  private readonly snackBar = inject(MatSnackBar);

  private dialogRef = inject(MatDialogRef);

  data: UserListData = inject(MAT_DIALOG_DATA);

  apiErrorMessage = signal('');

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  closeDialog() {
    this.snackBar.dismiss();
    this.dialogRef.close();
  }

  deleteUser() {
    this.customSnackbarSvc.requestSnackbar();

    this.subs.sink = this.profileApiSvc.deleteUser(this.data).subscribe({
      next: () => {
        this.dialogRef.close(true);
        this.customSnackbarSvc.successSnackbar('Thank you for deleting a user. It may take up to one business day to process the request and update the system.');
      },
      error: (error) => {
        this.apiErrorMessage.set(':' + error.message);
        this.customSnackbarSvc.errorSnackbar();
        console.error('Error deleting user ', error.message);
      },
    });
  }
}
